import { pathSelector } from './path_selector'
import { acceptors } from './acceptors'
import { pathInfoBuilder } from './path_info_builder'

const buildPath = (text: string) => {
    let leftBoundary = 0
    let path = pathSelector.createPath()

    acceptors.reset()

    for (let i = 0; i < text.length; i++) {
        let ch = text[i]

        acceptors.transit(ch)

        let possiblePathInfos = pathInfoBuilder.build(path, acceptors.getFinalAcceptors(), i, leftBoundary, text)

        let selectedPath = pathSelector.selectPath(possiblePathInfos)

        path.push(selectedPath)

        if (selectedPath.type !== 'UNK') {
            leftBoundary = i
        }
    }

    return path
}

const pathToRanges = (path: any) => {
    let e = path.length - 1
    let ranges = []

    while (e > 0) {
        let info = path[e]
        let s = info.p

        if (info.merge !== undefined && ranges.length > 0) {
            var r = ranges[ranges.length - 1]
            r.s = info.merge
            s = r.s
        } else {
            ranges.push({ s: s, e: e })
        }

        e = s
    }

    return ranges.reverse()
}

const rangesToText = (text: string, ranges: any, delimiter: string) => {
    return ranges
        .map(function (r: any) {
            return text.substring(r.s, r.e)
        })
        .join(delimiter)
}

export const cut = (text: string) => {
    let path = buildPath(text)
    let ranges = pathToRanges(path)

    return rangesToText(text, ranges, '|')
}

export const cutIntoRanges = (text: string, noText?: string) => {
    let path = buildPath(text)
    let ranges = pathToRanges(path)

    if (!noText) {
        ranges.forEach(function (r: any) {
            r.text = text.substring(r.s, r.e)
        })
    }

    return ranges
}

export const cutIntoArray = (text: string) => {
    let path = buildPath(text)
    let ranges = pathToRanges(path)

    return ranges.map(function (r) {
        return text.substring(r.s, r.e)
    })
}

export let WordcutCore = {
    buildPath,
    pathToRanges,
    rangesToText,
    cut,
    cutIntoRanges,
    cutIntoArray,
}
